import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from "@/views/Main.vue";
import Main2 from "@/views/Main2.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main2
  },
  {
    path: '/v2',
    name: 'Main2',
    component: Main
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
